import ChatNotificationView from './ChatNotificationView';

export default ChatNotificationView;
